var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0m0 3.6C10.048 3.6 3.6 10.048 3.6 18S10.048 32.4 18 32.4 32.4 25.952 32.4 18 25.952 3.6 18 3.6m1.273 5.927 5.4 5.4a1.8 1.8 0 0 1-2.546 2.546L19.8 15.146V25.26a1.8 1.8 0 1 1-3.6 0l-.001-10.114-2.326 2.327a1.8 1.8 0 0 1-2.376.15l-.17-.15a1.8 1.8 0 0 1 0-2.546l5.4-5.4a1.8 1.8 0 0 1 2.546 0"
})));
export default SvgIconUpload;